




import Vue from 'vue'

interface Data {
  margin: number
}

export default Vue.extend({
  name: 'SwipeNavButton',
  props: {
    direction: {
      type: String as Prop<'prev' | 'next'>,
      required: true
    },
    second: {
      type: Boolean as Prop<boolean>,
      default: false
    }
  },
  data(): Data {
    return {
      margin: 0
    }
  },
  mounted() {
    this.$nextTick(this.getPosition)
  },
  computed: {
    slotName(): string {
      return this.direction === 'prev' ? 'button-prev' : 'button-next'
    },
    buttonClasses(): any[] {
      return [`swiper-button-${this.direction}`, { second: this.second }]
    },
    styleObject(): Record<string, string> {
      if (this.second) {
        if (this.direction === 'prev') {
          return { left: `${this.margin}px` }
        } else {
          return { right: `${this.margin}px` }
        }
      }
      return {}
    }
  },
  methods: {
    // second適用時のボタン位置を取得する
    getPosition() {
      const el = this.$el as HTMLElement
      if (!el) return

      if (!this.second) {
        const rect = el.getBoundingClientRect()

        if (this.direction === 'prev') {
          this.margin = Math.round(rect.left)
        } else {
          this.margin = Math.round(window.innerWidth - rect.right)
        }
      }
    }
  }
})
